var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twitter",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.062 19.246",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_546",
    d: "M450.719,536.633c.008.207.012.417.012.628,0,6.422-4.758,13.823-13.462,13.823a13.149,13.149,0,0,1-7.253-2.182,9.456,9.456,0,0,0,1.129.065,9.335,9.335,0,0,0,5.876-2.079,4.752,4.752,0,0,1-4.42-3.372,4.569,4.569,0,0,0,.889.085,4.519,4.519,0,0,0,1.248-.171,4.828,4.828,0,0,1-3.8-4.764v-.06a4.635,4.635,0,0,0,2.144.607,4.892,4.892,0,0,1-2.1-4.042,4.954,4.954,0,0,1,.64-2.446,13.317,13.317,0,0,0,9.753,5.076,4.947,4.947,0,0,1-.122-1.106,4.8,4.8,0,0,1,4.73-4.858,4.665,4.665,0,0,1,3.453,1.534,9.263,9.263,0,0,0,3.005-1.177,4.846,4.846,0,0,1-2.079,2.688,9.288,9.288,0,0,0,2.717-.766A9.744,9.744,0,0,1,450.719,536.633Z",
    transform: "translate(-430.016 -531.839)",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.4758091229afc478b95d3be41b3950dd.svg";
export { ForwardRef as ReactComponent };